import { render, staticRenderFns } from "./chartSumCompaniesAnnually.vue?vue&type=template&id=125f5c3a&scoped=true&"
import script from "./chartSumCompaniesAnnually.vue?vue&type=script&lang=js&"
export * from "./chartSumCompaniesAnnually.vue?vue&type=script&lang=js&"
import style0 from "./chartSumCompaniesAnnually.vue?vue&type=style&index=0&id=125f5c3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "125f5c3a",
  null
  
)

export default component.exports